<template lang="pug">
#app(:data-aspect-ratio-auto='dataAspectRatioAuto')
  router-view
</template>

<script lang="ts">
import { Component, Vue, Watch } from 'vue-property-decorator'

@Component
export default class App extends Vue {
  // アスペクト比自動のデータ属性
  private dataAspectRatioAuto = false

  public created(): void {
    const router = this.$router

    history.pushState(null, '', location.href)
    // ブラウザバックを制御する
    window.addEventListener('popstate', () => {
      // 現在パスを取得し、管理系の場合は処理をスキップ
      const pathes = router.currentRoute.path.split('/')
      if (pathes[1] === 'admin' || pathes[1] === 'academy' || pathes[1] === 'branch') {
        return
      }

      // 履歴に現在ページのパスを追加し、リロードを抑制
      history.pushState(null, '', router.currentRoute.fullPath)
      router.go(1)
    })
  }

  private mounted() {
    this.setDataAttribute()
  }

  @Watch('$route', { deep: true })
  private onChangeRoute() {
    this.setDataAttribute()
  }

  // データ型のセット
  private setDataAttribute() {
    // 生徒学習画面はアスペクト比を自動とする
    this.dataAspectRatioAuto = this.$route.name === 'StudentStudy'
  }
}
</script>

<style lang="stylus">
@import "./assets/css/application.css";

#app
  // 表示エリアの縦横比固定+縦方向にサイズ超過する場合のスクロール設定
  overflow-y scroll
  // 学習メニュー非アクティブ時のスクロール抑止
  overflow-x hidden
  height 100%
  max-width 100%

  -webkit-font-smoothing antialiased
  -moz-osx-font-smoothing grayscale

  &[data-aspect-ratio-auto='true']
    aspect-ratio auto
</style>
